<div class="settings-container" *ngIf="testSettingsForm">
  <div class="filter-section">
  </div>
  <!-- {{testSettingsForm.status}} -->
  <div class="frm-container">
    <form [formGroup]="testSettingsForm" novalidate>
      <div class="btn-wrapper">
        <button mat-flat-button color="" cdkFocusInitial class="btn-primary" aria-label="Save"
          (click)="finalSaveTestSettigs()" [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)
          || isPublished || testSettingsForm?.status === 'INVALID' ? true : false">{{'testId.TabSettings.btnSave' |
          translate}}</button>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4">
            <label> {{'testId.TabSettings.label1' | translate}}<span class="red-asterisk"
                *ngIf="testDetailData.scoringTypeId != ScoringTypeEnum.OnOption">*</span></label>
            <input
              [readonly]="isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)"
              type="number" class="settingInput" formControlName="testDuration" min="0" max="9999"
              oninput="validity.valid||(value='')"><span>{{'testId.TabSettings.labelmin' | translate}}</span>
            <div *ngIf="f.testDuration.invalid && (f.testDuration.dirty || f.testDuration.touched )"
              class="alert alert-danger">
              <div *ngIf="f.testDuration.errors?.required">
                {{'testId.TabSettings.testDurationError1' | translate}}
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <label for=""> {{'testId.TabSettings.label2' | translate}}<span class="red-asterisk"
                *ngIf="testDetailData.scoringTypeId != ScoringTypeEnum.OnOption && testDetailData.scoringTypeId != ScoringTypeEnum.On180360Degree">*</span></label>
                <!-- <input [readonly]="isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)"
                type="number" min="0" class="settingInput" formControlName="passingCriteria"
                onkeypress="if((this.value.length == 4 && !this.value.includes('.')) || (this.value.length == 5 && this.value.includes('.')) ) return false;"
                (keypress)="omit_special_char($event)" (keyup)="replace2Decimal($event, testSettingsForm.controls, 'minimumScore')"> -->

                <input
              [readonly]="isPublished || (roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true)"
              type="number" class="settingInput" formControlName="passingCriteria" min="0"
              oninput="validity.valid||(value='')">
              <span>{{'testId.TabSettings.labelmarks' | translate}}</span>
            <div
              *ngIf="f.passingCriteria.invalid && f.passingCriteria.touched && (roleSer.accessData?roleSer.accessData.insertAllowed :true || roleSer.accessData?roleSer.accessData.updateAllowed :true)"
              class="alert alert-danger">
              <div *ngIf="f.passingCriteria.errors?.required">
                {{'testId.TabSettings.passScoreError1' | translate}}
              </div>
              <div *ngIf="f.passingCriteria.errors?.min">
                {{'testId.TabSettings.passScoreError2' | translate}}
              </div>
            </div>
          </div>
          <div class="col-md-4 status">
            <label for="">{{'testId.TabSettings.label3' | translate}}</label>
            <mat-form-field appearance="fill" class="test-status">
              <mat-select [(value)]="statusName" #selectList
                (selectionChange)="openConfirmationDialog(selectList.value)"
                [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished">
                <mat-option *ngFor="let status of testStatusList" [value]="status?.itemStatusId">
                  <p>{{status?.itemStatus}} </p>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2">
            <label for="">{{'testId.TabSettings.label6' | translate}}<span class="red-asterisk">*</span></label>
            <!-- <select class="form-control lang-dropdown" (change)="switchLang($event)" formControlName="language">
              <option *ngFor="let l of languageData" [value]="l.langId" [attr.data-id]="l.langId"
                [attr.data-label]="l.languagecode" [selected]="l.language == selectedLang">{{l.language}}</option>
            </select> -->
            <select class="form-control lang-dropdown" (change)="switchLang($event)" [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished">
              <option *ngFor="let l of languageData" [value]="l.langId" [attr.data-id]="l.langId"
               [attr.data-label]="l.languagecode" [selected]="l.langId == selectedLang">{{l.language}}</option>
            </select>
          </div>
          <div class="col-lg-2"></div>
          <div class="col-lg-2">
            <label>{{'testId.TabSettings.label4' | translate}}</label>
            <div *ngFor="let data of lstItemCategoryMaster" style="line-height: 30px;">
              {{data.itemCategoryName}}
            </div>
          </div>

          <div class="col-lg-2">
            <label>{{'testId.TabSettings.label5' | translate}}</label>
            <div *ngFor="let data of lstItemCategoryMaster" style="line-height: 30px;">
              <mat-slide-toggle class="example-margin" [(ngModel)]="data.enablequestionsequencing"
                [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished"
                [ngModelOptions]="{standalone: true}" (change)="categoryChange($event, data)">
              </mat-slide-toggle>
            </div>
          </div>
          <div class="col-lg-4"></div>
        </div>

        <!-- <div class="row" *ngFor="let data of lstItemCategoryMaster"
          style="line-height: 15px;">
          <div class="col-md-4"></div>
          <div class="col-md-4">
              {{data.itemCategoryName}}
          </div>

          <div class="col-md-4">
            <mat-slide-toggle class="example-margin" [(ngModel)]="data.enablequestionsequencing"
            [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true || roleSer.accessData?!roleSer.accessData.updateAllowed :true) || isPublished" [ngModelOptions]="{standalone: true}"
            (change)="categoryChange($event, data)">
            </mat-slide-toggle>
          </div>
        </div> -->
      </div>
    </form>
  </div>

</div>
